<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-25 14:54:50
 * @ Modified by: Your name
 * @ Modified time: 2019-08-07 13:47:41
 * @ Description: 配送记录
 -->

<template>
  <div class="content-wrapper">
    <el-form
      label-width="110px" label-position="right" ref="searchForm" :model="formData.data"
      class="search-form" :inline="true">
      <div class="grid-wrapper">
        <el-form-item label="配送时间" prop="deliveryTime">
          <el-date-picker
            v-model="deliveryTime"
            size='small'
            type="datetimerange"
            range-separator="-"
            format="yyyy-MM-dd HH:mm:ss"
            value-format='yyyy-MM-dd HH:mm:ss'
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="配送单号" prop="deliveryNumber">
          <el-input
            size="small" v-model="formData.data.deliveryNumber"
            placeholder="配送单号" clearable class="inputWidth160"/>
        </el-form-item>
        <el-form-item label="配送状态" prop="deliveryStatus">
          <el-select v-model="formData.data.deliveryStatus"
            clearable placeholder="请选择" size="small" class="inputWidth160">
            <el-option
              v-for="item in deliveryStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配送员手机号" prop="deliveryPersonPhone">
          <el-input
            size="small" v-model="formData.data.deliveryPersonPhone"
            placeholder="配送员手机号" clearable class="inputWidth160"/>
        </el-form-item>
        <el-form-item label="领取人手机号" prop="receivePersonPhone">
          <el-input
            size="small" v-model="formData.data.receivePersonPhone"
            placeholder="领取人手机号" clearable class="inputWidth160"/>
        </el-form-item>
        <el-form-item label="领取时间" prop="receiveTime">
          <el-date-picker
            v-model="receiveTime"
            size='small'
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format='yyyy-MM-dd HH:mm:ss'
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="飞机号" prop="aircraftNumber">
          <el-input
            size="small" v-model="formData.data.aircraftNumber"
            placeholder="飞机号" clearable class="inputWidth160"/>
        </el-form-item>
        <el-form-item label="工卡指令号" prop="workcardNumber">
          <el-input
            size="small" v-model="formData.data.workcardNumber"
            placeholder="工卡指令号" clearable class="inputWidth160"/>
        </el-form-item>

        <el-form-item label="智能柜编号" prop="deviceNumber">
          <el-input
            size="small" v-model="formData.data.deviceNumber"
            placeholder="智能柜编号" clearable class="inputWidth160"/>
        </el-form-item>
        <el-form-item label="柜门号" prop="cabinetDoorName">
          <el-input
            size="small" v-model="formData.data.cabinetDoorName"
            placeholder="柜门号" clearable class="inputWidth160"/>
          <!-- <el-button type="primary" size="small" class="btn160"
            @click="searchTableData" icon="el-icon-search"
            :loading="loadingSearch">查询</el-button> -->
        </el-form-item>

         <el-form-item label="领取人员工号" prop="receivePersonNo">
          <el-input
            size="small" v-model="formData.data.receivePersonNo"
            placeholder="领取人员工号" clearable class="inputWidth160"/>
          <el-button type="primary" size="small" class="btn160"
            @click="searchTableData" icon="el-icon-search"
            :loading="loadingSearch">查询</el-button>
        </el-form-item>
      </div>
    </el-form>
    <div class="tool-bar">
      <el-button class="download" size="small" icon="el-icon-download"
        @click="downLoadList" :loading="downLoading">下载列表</el-button>
      <el-button type="warning" size="small" icon="el-icon-user"
        @click="handleBtn('updateUser')">变更领取人手机号</el-button>
      <el-button type="success" size="small" icon="el-icon-message"
        @click="reSendShotMessage()">重发短信</el-button>
    </div>
    <span class="tips">( 提示：只有配送状态为已入柜才可以变更领取人手机号和重发短信 )</span>
    <table-pagination
      ref="table"
      :tableData="tableData"
      :height='500'
      :loading='tableLoading'
      :isCheckbox='isCheckbox'
      service
      @service-fn="handleService"
      @row-click="rowClick"
      @selection-change='selectionChange'
      >
      <el-table-column
        :selectable='isDisabled'
        type="selection"
        width="40">
      </el-table-column>
      <el-table-column prop="deviceNumber" label="智能柜编号" align="center"
        show-overflow-tooltip min-width="96"/>
      <el-table-column prop="deviceName" label="智能柜名称" align="center"
        show-overflow-tooltip min-width="96"/>
      <el-table-column prop="cabinetDoorName" label="柜门号" align="center"
        min-width="70" show-overflow-tooltip/>
      <el-table-column prop="deliveryPersonName" label="配送员" align="center"
        min-width="70" show-overflow-tooltip/>
      <el-table-column prop="deliveryPersonPhone" label="配送员手机号" align="center"
        min-width="120" show-overflow-tooltip/>
      <el-table-column prop="deliveryNumber" label="配送单号" align="center"
        min-width="150" show-overflow-tooltip/>
      <el-table-column
        prop="deliveryTime" label="配送时间" min-width="170" sortable :formatter='formatterTime'
        show-overflow-tooltip align="center"/>
      <el-table-column prop="deliveryStatus" label="配送状态"
        align="center" :formatter='formatDeliveryState' />
      <el-table-column prop="receivePersonNo" label="领取人员工号" align="center"
        width="120" show-overflow-tooltip/>
        <el-table-column prop="receivePersonPhone" label="领取人手机号" align="center"
        width="120" show-overflow-tooltip/>
      <el-table-column prop="actualReceiveName" label="实际领取人" align="center"
        show-overflow-tooltip width="100"/>
      <el-table-column prop="actualReceivePhone" label="实际领取人手机号" width="140"
        align="center" show-overflow-tooltip/>
      <el-table-column
        prop="receiveTime" label="领取时间" sortable :formatter='formatterTime'
        align="center" min-width="170" show-overflow-tooltip/>
      <el-table-column prop="exchangeStatus" label="领取人变更状态" align="center"
        show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span class="updateStatus" @click.stop="viewUpdateStatus(scope.row.id)">
            {{formatUpdateStatus(scope.row.exchangeStatus)}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="deliveryNumber" label="配送单详细信息" align="center"
        show-overflow-tooltip width="160">
        <template slot-scope="scope">
          <span class="updateStatus" @click.stop="viewRecordStatus(scope.row.id)">
            查看详细信息
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="receivePassword" label="领取密码" align="center" show-overflow-tooltip/>
      <el-table-column prop="deliveryPhoto" label="配送员照片" align="center" width="100">
        <template slot-scope="scope">
          <viewer v-if="scope.row.deliveryPhoto !=='' && scope.row.deliveryPhoto !=='null'">
            <img :src="arrayBufferToBase64(scope.row.deliveryPhoto)" class="imgs">
          </viewer>
        </template>
      </el-table-column>
      <el-table-column prop="receivePhoto" label="领取人照片" align="center" width="100">
        <template slot-scope="scope">
          <viewer v-if='scope.row.receivePhoto !=="" && scope.row.receivePhoto !=="null"'>
            <img :src="arrayBufferToBase64(scope.row.receivePhoto)" class="imgs">
          </viewer>
        </template>
      </el-table-column>
    </table-pagination>
    <!-- 这是变更领取人弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="mainDialogVisible"
      width="750px"
      >
      <dialog-main ref="dialogForm"
        :type="type"
        :id="dialogId"
        :receivePersonPhone='receivePersonPhone'
        :visible='mainDialogVisible'></dialog-main>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mainDialogVisible = false" size="small" type="info">取 消</el-button>
        <el-button @click="handleConfirm()" size="small" type="primary">确定</el-button>
      </span>
    </el-dialog>
    <!-- 这是领取人变更弹窗内容 -->
    <el-dialog title="查看变更领取人记录"
      :visible.sync="updataStatusVisible"
      width="680px">
      <el-table :data="updataStatusTabledata"
        border :height="400" class="updateStatusTable">
        <el-table-column property="receivePersonPhone"
          label="变更前领取人手机号" width="150" align="center"/>
        <el-table-column property="exchangePhone"
          label="变更后领取人手机号" width="150" align="center"/>
        <el-table-column property="updateDate"
          label="变更时间" align="center" :formatter='formatterTime'/>
        <el-table-column property="updateBy" label="操作人" align="center"/>
      </el-table>
    </el-dialog>
    <!-- 这是配送单详细信息 -->
    <el-dialog title="查看配送单详细信息"
      :visible.sync="recordDetailsVisible"
      width="780px">
      <el-table :data="recordDetailsData"
        border :height="400" class="updateStatusTable">
        <el-table-column property="aircraftNumber" width="110"
          label="飞机号" align="center"/>
        <el-table-column property="workcardNumber" width="180"
          label="工卡指令号" align="center"/>
        <el-table-column property="issueNumber" width="180"
          label="发料单号" align="center"/>
        <el-table-column property="materialName" show-overflow-tooltip
          label="工种" align="center">
          <template scope="scope">
            {{scope.row.materialName}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import tables from '../../mixins/table'
import handleBtn from '../../mixins/dialog/handleBtn'
import { DELIVERY_RECORD } from '../../libs/api'
import { saveFile } from '../../libs/utils/file'
import dialogMain from './dialogMain.vue'

export default {
  name: 'deliveryRecord', // 配送记录
  mixins: [tables, handleBtn],
  components: {
    dialogMain
  },
  data() {
    return {
      isCheckbox: true,
      receivePersonPhone: '',
      formInited: true, // 表单是否已完成初始化
      loadingSearch: false, // 查询按钮加载中
      tableLoading: false,
      updataStatusVisible: false, // 领取人状态变更弹窗
      recordDetailsVisible: false,
      downLoading: false,
      tableTypes: 'deliveryRecord',
      updataStatusTabledata: [],
      recordDetailsData: [],
      formData: {
        pageNum: 1,
        pageSize: 10,
        orderBy: '',
        data: {
          deviceNumber: '', // 智能柜编号
          cabinetDoorName: '', // 柜门编号
          deliveryPersonPhone: '', // 配送人手机号
          deliveryNumber: '', // 配送单号
          receivePersonPhone: '', // 领取人手机号
          deliveryStatus: '', // 配送状态
          receiveTime1: '', // 开始取件时间
          receiveTime2: '', // 结束取件时间
          deliveryTime1: '',
          deliveryTime2: '',
          aircraftNumber: '',
          workcardNumber: '',
          receivePersonNo: ''
        }
      },
      receiveTime: '', // 取件时间
      deliveryTime: '', // 配送时间
      dic: { // 字典格式化
        deliveryStatus: {
          0: '已取消',
          1: '已入柜',
          2: '已领取'
        },
        exchangeStatus: {
          1: '未变更',
          2: '已变更'
        }
      },
      deliveryStatusList: [{
        label: '已取消',
        value: 0
      }, {
        label: '已入柜',
        value: 1
      }, {
        label: '已领取',
        value: 2
      }],
      deliveryStatusCancel: 1,
      searchUrl: DELIVERY_RECORD.GET_LIST,
      downLoadListUrl: DELIVERY_RECORD.DOWNLOAD,
      updateUrl: DELIVERY_RECORD.UPDATE,
      inserRecordUrl: DELIVERY_RECORD.INSERTRECORD,
      findhistoryUrl: DELIVERY_RECORD.FINDHISTORY,
      finleRecordListUrl: DELIVERY_RECORD.RECORDFINDLIST,
      reSendUrl: DELIVERY_RECORD.RESEND
    }
  },
  mounted() {
    // table 数据表查询
    this.searchTableData()
  },
  methods: {
    searchTableData() {
      this.formatFormData()
      this.handleSearch(this.searchUrl, this.formData)
    },
    formatFormData() {
      // 将配送时间、取件时间 拆分成两个时间
      const params = ['deliveryTime', 'receiveTime']
      params.forEach(item => {
        if (this[item]) {
          /* eslint-disable */
          this.formData.data[`${item}1`] = this[item][0]
          this.formData.data[`${item}2`] = this[item][1]
        } else {
          /* eslint-disable */
          this.formData.data[`${item}1`] = ''
          this.formData.data[`${item}2`] = ''
        }
      })
    },
    formatDeliveryState(row, column, cellValue) { // 配送状态 格式化
      return this.dic.deliveryStatus[cellValue]
    },
    formatUpdateStatus(exchangeStatus) {
      return this.dic.exchangeStatus[exchangeStatus]
    },
    isDisabled(row, index) {
      if (row.deliveryStatus === this.deliveryStatusCancel) {
        return 1
      }
      return 0
    },
    rowClick(row) { // 重新该方法，处理禁用状态的行能够被勾选
      if (row.deliveryStatus !== this.deliveryStatusCancel) {
        return
      }
      this.$refs.table.toggleRowSelection(row)
    },
    selectionChange(selection) {
      this.selection = selection
    },
    resetForm(formName) { // 清空 form 表单
      this.receiveTime = ''
      this.deliveryTime = ''
      this.$refs[formName].resetFields()
    },
    arrayBufferToBase64(buffer) {
      return 'data:image/png;base64,' + buffer
    },
    downLoadList() { // 下载列表
      this.downLoading = true
      this.$http.post(this.downLoadListUrl, this.formData.data)
        .then(res => {
          this.downLoading = false
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', '下载列表失败')
            return
          }
          if (res.data.data.file) {
            saveFile(res.data.data.fileName, res.data.data.file, 'application/xml')
          } else {
            this.handleNotify('error', '提示', '下载excel文件内容不存在')
          }
          if (res.data.data.zipFile) {
            saveFile(res.data.data.zipFileName, res.data.data.zipFile, 'application/zip')
          } else {
            this.handleNotify('error', '提示', '下载压缩包文件内容不存在')
          }
        })
        .catch(err => {
          this.handleNotify('error', '错误', err || '下载列表失败')
        })
    },
    handleChangeReciveUser() { // 变更领取人
      // console.log('this.selection', this.selection)
      this.receivePersonPhone = this.selection[0].receivePersonPhone
      // 判断selection中领取人手机是否一致
      const isOnePerson = this.selection.every(item => item.receivePersonPhone === this.selection[0].receivePersonPhone)
      // const isOnePerson = true
      if (isOnePerson) {
        this.mainDialogVisible = true // 打开弹窗
      } else {
        this.handleNotify('error', '错误', '请选择同一个领取手机号用户数据')
      }
    },
    viewUpdateStatus(id) { // 查看领取人变更状态
      this.updataStatusVisible = true
      this.$http.post(this.findhistoryUrl, { id })
        .then(res => {
          if (res.data.code === 1) {
            this.updataStatusTabledata = res.data.data
          }
        })
    },
    viewRecordStatus(id) {
      this.$http.post(this.finleRecordListUrl, { recordId: id })
        .then(res => {
          const { code, data } = res.data
          if (code !== 1) {
            this.handleNotify('error', '错误', '获取配送单详细信息失败')
            return
          }
          this.recordDetailsData = data
          this.recordDetailsVisible = true
        })
        .catch(err => {
          this.handleNotify('error', '错误', err || '获取配送单详细信息失败')
        })
    },
    handleConfirm() { // 确认变更领取人手机号
      this.$refs.dialogForm.$children[0].validate(async valid => {
        if (valid) {
          const { exchangePhone } = this.$refs.dialogForm.dialogFormData
          const selection = [...this.selection]
          let updateData = []
          let insertData = []
          selection.forEach(item => {
            updateData.push({
              deviceName: item.deviceName,
              deliveryNumber: item.deliveryNumber,
              id: item.id,
              deliveryPersonId: item.deliveryPersonId,
              exchangeStatus: 2,
              receivePersonPhone: exchangePhone,
              exchangePhone: item.receivePersonPhone
            })
            insertData.push({
              recordType: 1,
              deliveryRecordId: item.id,
              receivePersonPhone: item.receivePersonPhone,
              exchangePhone,
              updateDate: new Date().getTime(),
              updateBy: ''
            })
          })
          // 先更新后插入
          const results =  await this.handleUpdate(updateData)
          if (results) { // 只有更新成功后才能进行插入操作
            this.handleInsert(insertData)
          }
        }
      })
    },
    handleUpdate(updateData) { // 更新领取人手机号
      return new Promise((resolve, reject) => {
        this.$http.post(this.updateUrl, updateData)
          .then(res => {
            if (res.data.code === 1) {
              this.searchTableData()
              this.handleNotify('success', '提示', '变更领取人手机号成功')
              this.mainDialogVisible = false
              resolve(true)
            } else {
              this.handleNotify('error', '错误', res.data.msg || '变更领取人手机号失败')
              this.mainDialogVisible = false
              resolve(false)
            }
          })
          .catch(err => {
            this.handleNotify('error', '错误', err || '变更领取人手机号失败')
            reject()
          })
      })
    },
    handleInsert(insertData) { // 插入领取人手机号
      this.$http.post(this.inserRecordUrl, insertData)
        .then(res => {
          if (res.data.code !== 1) {
            this.handleNotify('error', '错误', '变更领取人手机号insert操作失败')
          }
        })
        .catch(err => {
          this.handleNotify('error', '错误', err || '变更领取人手机号insert操作失败')
        })
    },
    reSendShotMessage() { // 重发短信
      const isSelectionOne = this.handleSelectOne(this.selection.length, 'reSend')
      if (!isSelectionOne) {
        return false
      }
      const param = this.selection.map(item => {
        return {
          deliveryRecordId: item.id,
          sendStatus: 0
        }
      })
      this.$http.post(this.reSendUrl, param)
        .then(res => {
          if (res.data.code === 1) {
            this.handleNotify('success', '提示', res.data.msg || '重发短信成功')
          } else {
            this.handleNotify('error', '错误', res.data.msg || '重发短信失败')
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  .imgs {
    height: 30px;
    display: block; // 消除图片下方的几个像素
  }
  .search{
    display: inline-block;
    margin: 4px 0px 0px 14px;
  }
  /deep/.inputWidth160{
    width: 160px;
    input{
      width: 160px;
      padding: 0px 8px;
    }
    /deep/label{
      padding: 0px 6px 0px 0px;
    }
  }
  .btn160{
    margin-left: 20px;
  }
  .download{
    background: #C5B32B;
    border: none;
    color: #fff;
  }
  .updateStatus{
    cursor: pointer;
    color: rgba(0, 89, 255, 0.733);
    display: block;
    padding: 4px;
  }
  .el-form-item{
    margin: 0px 0px 4px 0px;
  }
  /deep/.updateStatusTable {
    td, th{
      padding: 6px 0px;
    }
  }
  /deep/input:disabled + span{
    background: rgb(138, 135, 135);
  }
}
</style>
